import { useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import type { IEmployeeInfoAdminPatchDto } from '@/dtos/models';

interface AddressPayload {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zipcode: string;
  country_code: string;
  address_type: string;
}

const QUERY_KEY = 'GET_ADDRESS_UNDELIVERABLE';

const useUpdateEmployeeAddressQuery = () => {
  const { params: { id } } = useRouteMatch<{ id: string }>();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (address: AddressPayload) =>
      api.patch<IEmployeeInfoAdminPatchDto>(API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(id), {
        mailing_address: address,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      },
    },
  );

  const updateAddress = useCallback(
    async (address: AddressPayload) => {
      await mutation.mutateAsync(address);
    },
    [mutation],
  );

  return {
    updateAddress,
    isLoading: mutation.isLoading,
  };
};

export default useUpdateEmployeeAddressQuery;
